import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'

import { useLegacyPublicApi } from '@/services/api/ApiContext'
import { RESET_PASSWORD_REQUEST } from '@/services/endpoints'

import { useErrorHandler } from './useErrorHandler'

export const useRequestPasswordReset = (config = {}) => {
  const api = useLegacyPublicApi()
  const [error, setError] = useState(null)
  const resolvedError = useErrorHandler(error)

  const {
    mutateAsync: mutate,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: async (data) => {
      const payload = {}
      if (data.method === 'email') {
        payload.email = data.email
      } else if (data.method === 'phone') {
        payload.phone = data.phone
      } else {
        return Promise.reject({ response: { data: [{ Code: 100 }] } })
      }
      if (data.redirectUrl) {
        payload.redirectUrl = data.redirectUrl
      }
      return await api.post(RESET_PASSWORD_REQUEST, payload)
    },
    onSuccess: () => {
      setError(null)
    },
    onError: (error) => {
      setError(error)
    },
    ...config,
  })

  const requestPasswordReset = (data) => mutate(data)

  return {
    requestPasswordReset,
    isLoading,
    isSuccess,
    error: resolvedError,
  }
}
